module.exports = __webpack_public_path__ + "img/f12.71f12d85.png";